import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { HexToRGBA } from '@swp/colors';
import { getFilter } from '../transformation';
import { intrinsic, iframe, background } from './index.module.less';
import { jsx as ___EmotionJSX } from "@emotion/react";

function getUrl(_ref) {
  var embedId = _ref.embedId,
      autoplay = _ref.autoplay,
      startTime = _ref.startTime,
      endTime = _ref.endTime,
      loop = _ref.loop,
      rel = _ref.rel,
      modestbranding = _ref.modestbranding,
      controls = _ref.controls,
      ivLoadPolicy = _ref.ivLoadPolicy,
      fs = _ref.fs,
      mute = _ref.mute;
  var url = "https://www.youtube.com/embed/" + embedId;
  var searchParams = [];
  if (autoplay) searchParams.push('autoplay=1');
  if (startTime) searchParams.push("start=" + startTime);
  if (endTime) searchParams.push("end=" + endTime);
  if (loop) searchParams.push("loop=1");
  if (loop) searchParams.push("playlist=" + embedId);
  if (rel === false || rel === '0' || rel === 0) searchParams.push("rel=0");
  if (modestbranding === false) searchParams.push('modestbranding=1');
  if (controls === false) searchParams.push('controls=0');
  if (ivLoadPolicy === false) searchParams.push('ivLoadPolicy=3');
  if (fs === false) searchParams.push('fs=0');
  if (mute === true) searchParams.push('mute=1');
  if (searchParams.length) url += '?' + searchParams.join('&');
  return url;
}

export function YouTube(props) {
  return ___EmotionJSX("div", _extends({
    style: props.style
  }, process.env.ENV_RAW ? null : props.uiEvents), ___EmotionJSX("div", {
    className: intrinsic + " has-iframe"
  }, ___EmotionJSX("iframe", {
    className: iframe,
    title: "YouTube video",
    frameBorder: "0",
    src: getUrl(props),
    allow: "autoplay; fullscreen",
    allowFullScreen: true
  }), props.children));
}
export function YouTubeAsBackground(props) {
  var style;
  var overlay;

  if (props.transformations) {
    style = getFilter(props.transformations);

    if (props.transformations.overlay) {
      overlay = {
        '--filter-overlay': HexToRGBA(props.transformations.overlay, props.transformations.overlayAlpha)
      };
    }
  }

  return ___EmotionJSX("div", {
    className: background,
    style: overlay
  }, ___EmotionJSX("iframe", {
    style: style,
    title: "YouTube video",
    frameBorder: "0",
    src: getUrl(props),
    allow: "autoplay; fullscreen",
    allowFullScreen: true
  }));
}